module.exports = __webpack_public_path__ + "static/emma-f9c24225af15cc44c9c94d893b60590b.png";